module.exports = __webpack_public_path__ + "static/img/p6.cfa0bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p6.png
// module id = WZz2
// module chunks = 15